module.exports = __webpack_public_path__ + "img/delphoi_top.4170b653.png";